export default [
  {
    path: '/fhrm/deposit',
    name: 'fhrm_deposit',
    meta: {
      title: '押金'
    },
    component: () => import('views/fhrm/deposit')
  },
  {
    path: '/fhrm/deposit_ali',
    name: 'fhrm_deposit_ali',
    meta: {
      title: '胎心监护仪免押金'
    },
    component: () => import('views/fhrm/deposit_ali')
  },
  {
    path: '/fhrm/service_list',
    name: 'fhrm_service_list',
    meta: {
      title: '胎监服务'
    },
    component: () => import('views/fhrm/service_list')
  },
  {
    path: '/fhrm/service_detail',
    name: 'fhrm_service_detail',
    meta: {
      title: '胎监服务'
    },
    component: () => import('views/fhrm/service_detail')
  },
  {
    path: '/fhrm/device_refund_apply',
    name: 'fhrm_device_refund_apply',
    meta: {
      title: '提交归还申请'
    },
    component: () => import('views/fhrm/device_refund_apply')
  },
  {
    path: '/fhrm/billing_rules',
    name: 'fhrm_dbilling_rules',
    meta: {
      title: '详细租赁计费细则'
    },
    component: () => import('views/fhrm/billing_rules')
  },
]